import { getLastMonthDateRange } from '~/utils/date';
import { IHospitalListFilters } from '~/services/api/hospital/types';

const getInitialValues = (): IHospitalListFilters => ({
  programIds: [],
  facilities: [],
  eventIds: [],
  patientFullName: '',
  ...getLastMonthDateRange(),
});

export default getInitialValues;
